import { Component, Input, inject, OnInit } from '@angular/core';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { ClipboardService } from 'ngx-clipboard';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-records-accordion',
  templateUrl: './records-accordion.component.html',
  styleUrls: ['./records-accordion.component.scss'],
  standalone: false,
})
export class RecordsAccordionComponent implements OnInit {
  private rbs = inject(RightBridgeApiService);
  dialog = inject(MatDialog);
  private clippy = inject(ClipboardService);
  private snacky = inject(MatSnackBar);

  @Input() title;
  @Input() infoKey;
  @Input() recordDetail;
  @Input() panelVar;
  @Input() defaultOpen;
  openPanels = [];
  loading = false;

  constructor() {}

  ngOnInit(): void {
    if (this.defaultOpen) {
      if (this.recordDetail.length > 1) {
        this.recordDetail.map((record, index) => {
          if (record.IsPrimary) {
            this.openPanels.push(index);
          }
        });
      }

      if (this.recordDetail.length === 1 || this.openPanels.length === 0) {
        this.openPanels.push(0);
      }
    }
  }

  openPanel(index) {
    this.openPanels.push(index);
  }

  closePanel(index) {
    this.openPanels = this.openPanels.filter(panel => panel !== index);
  }

  emptyCellCheck(datapoint, infoPoint) {
    if (
      infoPoint.varSet &&
      datapoint[infoPoint.varSet] &&
      datapoint[infoPoint.varSet][infoPoint.varName]
    ) {
      return false;
    }

    if (
      infoPoint.varSet &&
      datapoint[infoPoint.varSet] &&
      !datapoint[infoPoint.varSet][infoPoint.varName]
    ) {
      return true;
    }

    if (datapoint[infoPoint.varName]) {
      return false;
    }

    return true;
  }

  decryptValue(value: string, title: string) {
    this.loading = true;
    this.rbs.decryptValue(value).subscribe({
      next: resp => {
        this.loading = false;
        if (resp['resultString']) {
          let dialogRef = this.dialog.open(WarnDialogComponent, {
            panelClass: 'warn-dialog',
            data: {
              headline: title,
              content: `Value: ${resp['resultString']}`,
              confirm: 'Copy to Clipboard',
              cancel: 'Close',
              hideCancel: false,
            },
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === 'continue') {
              this.clippy.copy(resp['resultString']);
              this.snacky.open(`Copied to clipboard!`, 'Close', {
                duration: 4000,
              });
            }
            dialogRef = null;
          });
        }
      },
      error: err => {
        this.loading = false;
        console.error('ERROR: ', err);
        this.snacky.open(
          `Oops! Something went wrong. Please try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
      },
    });
  }
}
